export default {
  brand: 'CrypPay',
  transferHint: '아래 주소로 송금해 주세요',
  rechargeAmount: '충전 금액',
  rechargeAddress: '충전 주소',
  scanTip: '지갑으로 QR 코드를 스캔하여 송금하세요',
  copy: '복사',
  copied: '복사됨',
  copyFail: '복사 실패',
  networkFee: '네트워크 수수료',
  eta: '예상 입금 시간',
  etaVal: '5~15분',
  actualArrival: '실제 입금 금액',
  noticeTitle: '충전 안내',
  notice1: '현재 페이지에 표시된 QR 코드 또는 주소로만 송금해 주세요. 잘못된 주소로 송금한 자산은 복구할 수 없습니다.',
  notice2: '송금 금액은 반드시 {amount} {coin}와 정확히 일치해야 하며, 금액이 다를 경우 자동 입금되지 않습니다.',
  notice3: '블록체인 네트워크 확인을 기다려 주세요. (일반적으로 1회 확인 후 자동 입금)',
  notice4: '블록체인 송금은 취소할 수 없으며, 사용자 실수로 인한 손실은 본인이 부담해야 합니다.',
  selectLang: '언어 선택',
  back: '뒤로',
  pending: '결제 대기',
  paid: '결제 완료',
  timeout: '시간 초과',
  orderNo: '주문 번호',
  loading: '로딩 중…',
  paramError: '링크 매개변수가 올바르지 않습니다',
  initFail: '주문 생성 실패',
  paidSuccess: '결제 성공',
  timedOut: '주문이 만료되었습니다. 다시 시도해 주세요'
}